<template>
  <div>
    <form>
      <div class="mx-1">
        <span><b>{{ $t('lookUpVoucher.voucherInfo') }}</b></span>
        <div class="divider-text bg-light"></div>
      </div>
      <div class="d-flex row flex-nowrap wrap-container my-2 mx-1" style="justify-content: space-between">
        <div class="column">
          <div>
            <img class="voucher-image" :src="voucher.issuanceImage ? voucher.issuanceImage : voucherDefaultImg" alt="">
          </div>
          <div class="form-group voucher-content font-size-medium mt-2">
            <p class="font-weight-bold">{{ voucher.issuanceType != issuanceType.PROMOTION ? voucher.workpiece.name : voucher.name}}</p>
            <p>{{ $t('lookUpVoucher.voucherSupplier') }}: <b>{{ voucher.issuanceType != issuanceType.PROMOTION ? voucher.ownerVoucher.name : voucher.owner }}</b></p>
            <p v-if="!voucher.isHidePrice" class="font-weight-bold primary-color">
              {{ voucher.issuanceType != issuanceType.COUPON
              ? $t('lookUpVoucher.voucherPrice') : $t('lookUpVoucher.voucherDiscount')}}:
              {{ voucher.issuanceType != issuanceType.COUPON 
              ? `${convertToMoney(voucher.value)}  VND` : `${voucher.value} %` }}</p>
          </div>
        </div>
        <div class="column right-pane">
          <div class="form-group text-center" v-if="voucher.issuanceType != issuanceType.PROMOTION && voucher.activeCodeQr">
            <qrcode-vue
              :value="voucher.activeCodeQr"
              :size="qrCode.size"
              level="H"/>
          </div>
          <div class="form-group text-center" v-if="voucher.issuanceType == issuanceType.PROMOTION && voucher.codeQr">
            <qrcode-vue
              :value="voucher.codeQr"
              :size="qrCode.size"
              level="H"/>
          </div>
          <div class="form-group voucher-content font-size-medium">
            <p>{{ $t('lookUpVoucher.seriNumber') }}: <b>{{ voucher.serial }}</b></p>
            <div v-if="voucher.issuanceType != issuanceType.PROMOTION">
              <p v-if="voucher.activeCodeQr && isShowActiveCode">{{ $t('lookUpVoucher.activationCode') }}: <b>{{ voucher.activeCode }}</b></p>
              <p v-if="voucher.activeCodeQr">{{ $t('lookUpVoucher.expiredDate') }}:
                <span :class="isAlmostExpired(voucher.expiredDate)"><b>{{ voucher.expiredDate }}</b></span>
              </p>
              <p v-if="isTranferred">{{ $t('lookUpVoucher.fullName') }}: <b>{{ voucher.toUserTransferred.full_name }}</b></p>
              <p v-if="isTranferred">{{ $t('lookUpVoucher.email') }}: <b>{{ voucher.toUserTransferred.email }}</b></p>
            </div>
            <div v-else>
              <p>{{ $t('lookUpVoucher.expiredDate') }}:
                <span :class="isAlmostExpired(voucher.expiredDate)"><b>{{ voucher.expiredDate }}</b></span>
              </p>
              <p v-if="voucher.remainQuantity > 0">{{ $t('evoucher.remainQuantity') }}: <span class="font-weight-bold primary-color">{{ voucher.remainQuantity }}</span></p>
              <p v-else style="color: red;"><b>{{ $t('evoucher.quantityIsOver') }}</b></p>
            </div>
          </div>
        </div>
      </div>
      <div class="divider-text bg-light"></div>
      <div class="form-group pt-3 font-size-medium">
        <div class="d-block mb-2">
          <span class="font-weight-bold" :style="`cursor: pointer; border-bottom: ${tabVoucherInfoSelected == tabsVoucherInfo.DESCRIPTION ? '1px' : '0px'} solid black;`" @click="onSelectTab(tabsVoucherInfo.DESCRIPTION)">{{ $t('evoucher.description') }}</span>
          <span class="mx-2"> | </span>
          <span class="font-weight-bold" :style="`cursor: pointer; border-bottom: ${tabVoucherInfoSelected == tabsVoucherInfo.TERM ? '1px' : '0px'} solid black;`"  @click="onSelectTab(tabsVoucherInfo.TERM)">{{ $t('printEVoucher.termConditions') }}</span>
          <span class="mx-2"> | </span>
          <span class="font-weight-bold" :style="`cursor: pointer; border-bottom: ${tabVoucherInfoSelected == tabsVoucherInfo.ADDRESS_USAGE ? '1px' : '0px'} solid black;`"  @click="onSelectTab(tabsVoucherInfo.ADDRESS_USAGE)">{{ $t('evoucher.addressUsage') }}</span>
          <span v-if="forConasi" class="mx-2"> | </span>
          <span v-if="forConasi" class="font-weight-bold" :style="`cursor: pointer; border-bottom: ${tabVoucherInfoSelected == tabsVoucherInfo.EXTRA_INFO ? '1px' : '0px'} solid black;`"  @click="onSelectTab(tabsVoucherInfo.EXTRA_INFO)">{{ $t('evoucher.extraInfo') }}</span>
        </div>
        <div style="max-height: 300px; overflow-y: auto;">
          <span v-if="tabVoucherInfoSelected == tabsVoucherInfo.DESCRIPTION" class="pre-text">{{ voucher.description }}</span>
          <span v-else-if="tabVoucherInfoSelected == tabsVoucherInfo.TERM" class="pre-text">{{ voucher.conditionsOfUse }}</span>
          <span v-else-if="tabVoucherInfoSelected == tabsVoucherInfo.EXTRA_INFO" class="pre-text">{{ voucher.details }}</span>
          <div v-else v-for="(address, index) in voucher.usageSites" :key="address + index">
            <span class="font-weight-bold mt-2" style="display: block;">{{ index + 1 + '. ' + address.name }}</span>
            <div v-if="address.fullAddress" class="voucher-address">
              <i class="fas fa-map-marker mt-1 mr-2" />
              <span v-if="address.latitude && address.longitude">
                <a :href="`https://www.google.com/maps/place/${address.latitude},${address.longitude}/@${address.latitude},${address.longitude},19z`" target="_blank">{{ address.fullAddress }}</a>
              </span>
              <span v-else> {{ address.fullAddress }}</span>
            </div>
            <div v-if="address.email" class="voucher-address">
              <i class="fas fa-envelope mt-1 mr-2" />
              <a :href="`mailto:${address.email}`">{{ address.email }}</a>
            </div>
            <div v-if="address.phone" class="voucher-address">
              <i class="fas fa-phone mt-1 mr-2" />
              <a :href="`tel:${address.phone}`">{{ address.phone }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="divider-text bg-light"></div>
      <div v-if="voucher.issuanceType != issuanceType.PROMOTION && isShowBtnAction" :class="['pt-2', forConasi ? '' : 'text-right']">
        <button
          v-if="voucher.status != VoucherStatusType.USED && voucher.status != VoucherStatusType.WAITING && !isExpired(voucher.expiredDate) && !isTranferred"
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          @click="doAssignVoucher($event)">{{ $t('transactionBetweenCustomer.transactionSingle') }}</button>
        <button
          v-if="voucher.status == VoucherStatusType.WAITING"
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          @click="doConfirmUsedVoucher($event)">{{ $t('evoucher.confirmUsed') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import QrcodeVue from "qrcode.vue";
import functionUtils from "Utils/functionUtils";
import Enum from "Enum/enum";
import dateUtils from "Utils/dateUtils";
import { FOR_CONASI_TARGET, NUMBER_OF_ALMOST_EXPIRED_DATE } from 'Utils/constants'
import VoucherStatusType from "Enum/voucherStatusType";
import Vue from 'vue';
export default {
  components: {
    QrcodeVue,
  },
  props: ['voucher', 'isTranferred', 'isShowBtnAction', 'isShowActiveCode'],
  data: () => ({
    forConasi: FOR_CONASI_TARGET,
    voucherDefaultImg: Enum.Evoucher_Img_Default,
    qrCode: {
      size: 150,
    },
    issuanceType: Enum.issuanceType,
    VoucherStatusType: VoucherStatusType,
    tabsVoucherInfo: {
      DESCRIPTION: 1,
      TERM: 2,
      ADDRESS_USAGE: 3,
      EXTRA_INFO: 4
    },
    indexRetrievingAddessUsage: 0,
    tabVoucherInfoSelected: 1
  }),
  watch: {
    voucher () {
      this.tabVoucherInfoSelected = 1
      this.indexRetrievingAddessUsage = 0
      this.doRetrievingFullAddressUsage()
    }
  },
  created() {
    this.indexRetrievingAddessUsage = 0
    this.doRetrievingFullAddressUsage()
  },
  methods: {
    /**
     * Select tab
     */
    onSelectTab: function (tabType) {
      this.tabVoucherInfoSelected = tabType
    },
    /**
     * Format date with timezone to format DD/MM/YYYY
     */
    formatDate: function (date) {
      return date ? dateUtils.formatDate(
          date,
          dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
          dateUtils.STATIC_FORMAT_DATE
        ) : ''
    },
    /**
     * Convert to money
     */
    convertToMoney: function(value) {
      return functionUtils.convertFormatNumberToMoney(value);
    },
    isExpired: function(endDate) {
      var days = dateUtils.getRemainDays(endDate)
      return (days <= 0)
    },
    isAlmostExpired: function (endDate) {
      if (this.voucher.status != this.VoucherStatusType.USED) {
        var days = dateUtils.getRemainDays(endDate)
        return (days <= NUMBER_OF_ALMOST_EXPIRED_DATE) ? 'almost-expired' : ''
      }
      return ''
    },
    /**
     * Assign e voucher
     */
    doAssignVoucher: function(event) {
      this.$emit('doAssignVoucher', event)
    },
    /**
     * Confirm to use voucher
     */
    doConfirmUsedVoucher: function(event) {
      this.$emit('doConfirmUsedVoucher', event)
    },
    doRetrievingFullAddressUsage: function () {
      if (this.indexRetrievingAddessUsage >= 0 && this.voucher && this.voucher.usageSites && this.indexRetrievingAddessUsage < this.voucher.usageSites.length) {
        let addressFilter = {
          params: {
            countryCode: 84,
            cityCode: this.voucher.usageSites[this.indexRetrievingAddessUsage].province,
            districtCode: this.voucher.usageSites[this.indexRetrievingAddessUsage].district,
            wardCode: this.voucher.usageSites[this.indexRetrievingAddessUsage].ward
          }
        }
        this.GET_ADDRESS_DETAIL(addressFilter).then(
          function (res) {
            let fullAddress = functionUtils.concatFullAddress(res.data, this.voucher.usageSites[this.indexRetrievingAddessUsage].street)
            Vue.set(this.voucher.usageSites[this.indexRetrievingAddessUsage], 'fullAddress', fullAddress)
            // get update next item if any
            this.indexRetrievingAddessUsage++
            this.doRetrievingFullAddressUsage()
          }.bind(this)
        )
      }
    },
    ...mapActions(['GET_ADDRESS_DETAIL'])
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";

.voucher-content p{
  margin-bottom: 0;
  word-break: break-all;
}
.divider-text {
  position: relative;
  text-align: center;
}
.divider-text:after {
  content: "";
  position: absolute;
  width: 100%;
  border-bottom: 1px solid #ddd;
  top: 55%;
  left: 0;
  z-index: 1;
}
.voucher-address {
  display: flex;
  margin-left: 1em;
}
.right-pane {
  padding-left: .5em;
}
.almost-expired {
  font-weight: 700;
  color: red;
}
.voucher-image {
  max-width: 300px !important;
  max-height: 200px !important;
  border: 1px solid lightgray;
}
</style>
